import { AuthContext } from 'modules/Auth'
import { ForgotPassword } from 'modules/Auth/screens/ForgotPassword'
import { RedefinePassword } from 'modules/Auth/screens/RedefinePassword'
import { useContext } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

export function PasswordReset() {
  const { token } = useContext(AuthContext)
  const location = useLocation()

  if (token) {
    return <Navigate to="/" replace />
  }

  const queryParams = new URLSearchParams(location.search)
  const tokenParam = queryParams.get('token')

  if (tokenParam) {
    return <RedefinePassword token={tokenParam} />
  }

  return <ForgotPassword />
}
